module.exports = __webpack_public_path__ + "static/assets/3c3142e814ff1652338af92a410d3d70.svg";